// extracted by mini-css-extract-plugin
module.exports = {"Row":"StatsSection_Row__1ZDCi","Column":"StatsSection_Column__Lp9U8"};